import React, { useState, useEffect} from 'react';
import { useParams } from "react-router";
import { useNavigate } from 'react-router-dom';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import Menu from '../../components/sturtural/Menu';
import { Dialog } from 'primereact/dialog';
import ScannerDevolucion from '../../components/sturtural/ScannerDevolucion';
import Scanner from '../../components/sturtural/Scanner';
import { BASE_API } from '../../api/Globals';
import { helpHttp } from '../../helpers/helpHttp';
import { storage } from '../../helpers/storage';



const CambioScanner = () => {

    const navigate = useNavigate();
    let {q} = useParams();
    
    const init = {
        "IdEncEntrega": 0,
        "IdEncEntregaArray": [],
        "DetEntrega": [],
        "lstPrendasViejas": [],
        "IdUsuario": storage.get('id'),
        "FotoFrente": "",
        "FotoReverso": "",
        "FotoComprobante": "",
        "FotoFirma": "",
        "FechaModificacion": "",
        "IdTutorSeleccionado": 50056,
        "IdAlumno": 0,
        "IdEstatus": 2,
        "IdMotivoCancelacion": 0,
        "OtroMotivoCancelacion": "",
        "IdAlumnosArray": [],
        "JustificacionDeCancelacion": "",
        "IdTipoDocumento": 1,
        "IdDocumento": 1,
        "JustificacionDeCancelacion": "",
        "IsEntrega": true
    }

    const [menusa, setMenusa] = useState(true);
    const [scanner, setScanner] = useState(false);
    const [confirmScanner, setConfirmScanner] = useState(false);
    const [alumno, setAlumno] = useState(null);
    const [prendas, setPrendas] = useState(null);
    const [prenda, setPrenda] = useState([]);
    const [loading, setLoading] = useState(true);
    const [envio, setEnvio] = useState(init);

    const [frontal, setFrontal] = useState(null);
    const [reverso, setReverso] = useState(null);
    const [firma, setFirma] = useState(null);
    const [comprobante, setComprobante] = useState(null);

    const [message, setMessage] = useState(null);
    const [resumen, setResumen] = useState(false);
    const [aviso, setAviso] = useState(false);

    const ciclo = storage.get('ciclo');

    useEffect(() => {
        if(isNormalInteger(q)) {
            setLoading(true);
            helpHttp().post(`${BASE_API}DetalleEntrega/ObtenerDetalleEntrega/${q}?IdCicloEscolar=${ciclo.IdCicloEscolar}`, {
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${storage.get('token')}`
                },
            }).then(res => {
                if(!res.err) {
                    if(parseInt(res.IdAlumno) === parseInt(q)) {
                        setAlumno(res);
                        setPrendas(res.PrendasActivas);

                        getImagen(res.IdDocFrontal).then(x => setFrontal(x?.split(',')[1]));
                        getImagen(res.IdDocReverzo).then(x => setReverso(x?.split(',')[1]));
                        getImagen(res.IdDocFirma).then(x => setFirma(x?.split(',')[1]));

                        if(res.IdComprobante > 0) {
                            getImagen(res.IdComprobante).then(x => setComprobante(x?.split(',')[1]));
                        }

                        setEnvio(prevState => ({
                            ...prevState,
                            IdEncEntregaArray: [...prevState.IdEncEntregaArray, res.IdEncEntrega],
                            IdAlumnosArray: [...prevState.IdAlumnosArray, res.IdAlumno],
                            IdTutorSeleccionado: res.IdTutor,
                            lstPrendasViejas: res.PrendasActivas,
                            IdTienda: 1288,
                            IdAlumno: res.IdAlumno
                        }));
                        

                    } else {
                        setAlumno(null);
                    }
                } else {
                    setAlumno(null)
                }
                setLoading(false);
            });
        } else {
            //setMessage("Faltan parametros importantes para realizar este proceso");
        }
    },[q]);

    useEffect(() => {
        setEnvio(prevState => ({
            ...prevState,
            FotoFrente: frontal,
            FotoReverso: reverso,
            FotoComprobante: firma,
            FotoFirma: comprobante
        }));
    },[frontal, reverso, firma, comprobante]);

    const getImagen = (IdDoc) => {
        let imagen = helpHttp().post(`${BASE_API}DetalleEntrega/ObtenerImagen/${IdDoc}`, {
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            },
        })
        return imagen;
    }

    const handlePrendaDevolucion = (qr) => {
        alert(qr);
    }

    const isNormalInteger = (str) => { 
        let n = ~~Number(str); 
        return String(n) === str && n >= 0; 
    }

    const detalleYaExiste = (detalle) => {
        return envio.DetEntrega.some(
          det => JSON.stringify(det) === JSON.stringify(detalle)
        );
    };

    useEffect(() => {
        //console.log(envio);
    },[envio]);

    const handlePrenda = (arrPrenda, selection) => {
        //console.log(alumno);
        if (!detalleYaExiste(selection)) {  

            setEnvio(prevState => ({
                ...prevState,
                DetEntrega: [...prevState.DetEntrega, selection]
            }));
            
            setPrenda([...prenda, arrPrenda]);
        } else {
            alert('YA SELECCIONASTE ESTA PRENDA');
        }
        // agregar tres prendas
        // que no se repita una prenda
        setScanner(false);
    }

    const prendaXalumno = () => {
        return (
            <>
                { prenda.map((talla, x) => <li className="flex align-items-center mb-3" key={x}>
                    <i className="pi pi-check-circle text-green-500 mr-2"/>
                        <span>{talla.Prenda} {talla.Talla}</span>
                    </li>)
                }
            </>
        );
    }

    const handleSubmit_finalizar_qr = () => {
        console.log(envio);
        setMenusa(false);

        document.body.style.overflow = 'auto';
        
        setLoading(true);

        helpHttp().post(`${BASE_API}Entrega/CambiosUniformes`, {
            body: {...envio, IdCicloEscolar: ciclo.IdCicloEscolar},
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Access-Control-Allow-Origin': '*',
                'Authorization': `Bearer ${storage.get('token')}`
            },
        }).then((res) => {

            console.log(res);

            if(res.SUCCESS === true) {
                //setMessage(res.MESSAGE);
               // setResumen(true);
               // setAviso(true);
            } else if(res.SUCCESS === false) {
               // setMessage('(Error: 022) Error de conexión, Favor de iniciar el proceso nuevamente');
               // setAviso(true);
            } else {
               // setMessage('(Error: 021) Ocurrió un error al intentar realizar este proceso');
               // setAviso(true);
            }

            setMenusa(true);
            setLoading(false);
        });
    }

    const basicDialogFooter = <Button type="button" label="Aceptar" onClick={() => handlerRedirect(false)} icon="pi pi-check" className="p-button-secondary" />;

    const handlerRedirect = () => {
        if(resumen){
            //window.location.href = `/resumen/${q}`;
        } else {
            setMessage(null);
            setAviso(false)
        }
    }

    return (
        <>
            { menusa && <Menu link='nueva-solicitud' /> }

            <div className="grid">
                <div className="col-12 md:col-6">
                    <div className="card">
                        <h5>Devoluciones:</h5>
                        <div className="formgroup-inline">
                            <div className="field">
                                <label htmlFor="txt-clave" className="p-sr-only">Clave</label>
                                <InputText id="txt-clave" type="text" placeholder="Clave prenda" />
                            </div>
                            <Button label="Validar" className="mr-2 mb-2"></Button>
                            <Button icon="pi pi-qrcode" className="mr-2 mb-2" onClick={() => setConfirmScanner(true)}></Button>
                        </div>
                        <div className="formgroup-inline mr-2 mb-2 p-3">
                            <ul className="list-none p-0 m-0 flex-grow-1">
                                {prendas && prendas.map((el, index) => 
                                    <li className="flex align-items-center mb-3" key={index}>
                                        <i className="pi pi-check-circle text-green-500 mr-2"></i>
                                        <span>{el.Prenda} {el.Talla}</span>
                                    </li>
                                )}
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="col-12 md:col-6">
                    <div className="card">
                        <h5>Nueva Entrega:</h5>
                        <div className="formgroup-inline">
                            <div className="field">
                                <label htmlFor="txt-clave" className="p-sr-only">Clave</label>
                                <InputText id="txt-clave" type="text" placeholder="Clave prenda" />
                            </div>
                            <Button label="Validar" className="mr-2 mb-2"></Button>
                            <Button icon="pi pi-qrcode" className="mr-2 mb-2" onClick={() => setScanner(true)}></Button>
                        </div>
                        <div className="formgroup-inline mr-2 mb-2 p-3">
                            <hr className="my-3 mx-0 border-top-1 border-bottom-none surface-border"/>
                            <ul className="list-none p-0 m-0 flex-grow-1">
                                {prendaXalumno()}
                            </ul>
                        </div>
                        <hr className="mb-3 mx-0 border-top-1 border-none surface-border mt-auto" />
                        <Button label="Finalizar Cambio" className="mr-2 mb-2" onClick={() => handleSubmit_finalizar_qr()}></Button>
                    </div>
                </div>
            </div>

            <Dialog header="Scanner QR" visible={confirmScanner} onHide={() => setConfirmScanner(false)} style={{ width: '500px' }} modal className="p-fluid" >
                { confirmScanner && <ScannerDevolucion alumno={alumno} handlePrendaDevolucion={handlePrendaDevolucion} /> } 
            </Dialog>

            <Dialog header="Scanner QR" visible={scanner} onHide={() => setScanner(false)} style={{ width: '500px' }} modal className="p-fluid" >
                { scanner && <Scanner alumno={alumno} handlePrenda={handlePrenda} /> }
            </Dialog>

            <Dialog header="Aviso" visible={aviso} onHide={() => handlerRedirect} style={{ width: '400px' }} modal className="p-fluid" footer={basicDialogFooter}>
                <p>{message && message}</p>
            </Dialog>
        </>
        
    )
}

export default CambioScanner;